import { RootState } from '../states/root.state'
import { createSelector, select } from '@ngrx/store'
import { parseISOLangToSimplified } from '@core/utils/i18n.utils'
import { environment } from '@env'
import { pipe } from 'rxjs'
import { distinctUntilChanged, filter } from 'rxjs/operators'

export const selectUser = (state: RootState) => state.user

export const selectProfile = createSelector(selectUser, (state) => state.profile)
export const selectAvatar = createSelector(selectProfile, (profile) => profile.avatar || profile.avatarPath)

export const selectUserApplicationsProfile = createSelector(selectUser, (user) => user.applications)

export const selectIsoLang = createSelector(selectProfile, (profile) => profile?.language)

export const selectSimplifiedLang = createSelector(
  selectProfile,
  (profile) => profile && parseISOLangToSimplified(profile?.language)
)

export const selectFavourites = createSelector(selectProfile, (profile) => profile?.favourites)

export const selectFavTeamId = createSelector(selectFavourites, (favourites) => favourites?.teamId)

export const selectFavCompetitionId = createSelector(selectFavourites, (favourites) => favourites?.competitionId)

export const selectUserIsLoading = createSelector(selectUser, (state) => state.loading)

export const selectTenantConfiguration = createSelector(selectProfile, (profile) => profile?.tenantConfiguration)

export const selectTenantLanguages = createSelector(selectTenantConfiguration, (config) => config?.supportedLanguages)

export const selectTenantLanguagesAsDropdown = createSelector(selectTenantLanguages, (langs) =>
  langs?.map((lang) => ({ value: lang.id, label: lang.translationKey }))
)

export const selectIsoLangWithAvailableLanguages = createSelector(
  selectIsoLang,
  selectTenantLanguages,
  (lang, languages) => ({ lang, languages })
)

export const selectLangAsISO = (lang: string) =>
  createSelector(selectTenantLanguages, (languages) => {
    if (languages?.length) {
      const language = languages?.find((l) => new RegExp(lang, 'i').test(l.id))
      return language?.id ?? environment.i18nDefaultLang
    }
  })

export const selectDistinctSimplifiedLang = () =>
  pipe(
    select(selectSimplifiedLang),
    distinctUntilChanged(),
    filter((lang) => !!lang)
  )
